import { render, staticRenderFns } from "./ErrorBanner.vue?vue&type=template&id=65897be5"
import script from "./ErrorBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./ErrorBanner.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ErrorBanner.vue?vue&type=style&index=0&id=65897be5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports